export default __webpack_public_path__ + "static/media/example-product2.3587b70e.jpeg";